import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import React from "react";

import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
export default function TransferProductCommissionsFormRow({
  item,
  index,
  handleTransferProductCommissionsFrom,
  transfeProductCommissionsValidation,
  disabled,
  promoterOptions,
  removeTransferProductCommissionsFromData,
  productOptions,
  currentDate,
}) {
  const ajustFormRow = React.useMemo(
    () => (
      <Stack key={index} sx={{ my: 2 }} direction={"row"} spacing={2}>
        <Stack
          direction={"row"}
          justifyContent="space-between"
          alignItems={"flex-start"}
          sx={{ flex: 7 }}
          spacing={1}
        >
          <DatePicker
            sx={{ flex: 1 }}
            disabled={disabled}
            id="date"
            name="date"
            label="日期"
            minDate={moment(currentDate).startOf("month").format("YYYY-MM-DD")}
            maxDate={moment(currentDate).endOf("month").format("YYYY-MM-DD")}
            value={item.date}
            onChange={(value) => {
              handleTransferProductCommissionsFrom(
                index,
                "date",
                moment(value).format("YYYY-MM-DD")
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                error={!!transfeProductCommissionsValidation[index]?.dateErr}
                helperText={transfeProductCommissionsValidation[index]?.dateErr}
              />
            )}
          ></DatePicker>
          <Autocomplete
            sx={{ flex: 1 }}
            required
            disabled={disabled}
            id="combo-box-demo"
            options={promoterOptions}
            value={item.transferUser}
            onChange={async (e, newValue) => {
              handleTransferProductCommissionsFrom(
                index,
                "transferUser",
                newValue
              );
            }}
            label="員工"
            renderInput={(params) => <TextField {...params} label="員工" />}
          />
          <TextField
            disabled={true}
            value={item.rosterString}
            id="outlined-basic"
            label="更表"
            variant="outlined"
          />
          <ProductAutoComplete
            multiple={false}
            disabled={disabled}
            sx={{ width: 250, flex: 7 }}
            productOptions={productOptions}
            handleOnChange={(value) => {
              handleTransferProductCommissionsFrom(index, "productId", value);
            }}
            selectedValue={item.productId ?? []}
            error={!!transfeProductCommissionsValidation[index]?.productIdErr}
          ></ProductAutoComplete>
          <Box sx={{ flex: 0.5, display: "flex", justifyContent: "center" }}>
            <TextField
              disabled={disabled}
              error={
                !!transfeProductCommissionsValidation[index]?.transferQtyErr
              }
              helperText={
                transfeProductCommissionsValidation[index]?.transferQtyErr
              }
              sx={{ maxWidth: 125, minWidth: 125 }}
              value={item.transferQty}
              type="number"
              id="outlined-basic"
              label="調整數量"
              variant="outlined"
              onChange={(event) =>
                handleTransferProductCommissionsFrom(
                  index,
                  "transferQty",
                  event.target.value
                )
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">件</InputAdornment>
                ),
              }}
            />
          </Box>
        </Stack>
        {!disabled && (
          <Stack
            direction={"row"}
            justifyContent="space-between"
            alignItems={"flex-start"}
            sx={{ flex: 1 }}
          >
            <IconButton
              color="error"
              onClick={() => removeTransferProductCommissionsFromData(index)}
            >
              <DeleteForeverIcon></DeleteForeverIcon>
            </IconButton>
          </Stack>
        )}
      </Stack>
    ),
    [item, index, removeTransferProductCommissionsFromData]
  );
  return ajustFormRow;
}
